module.exports = __webpack_public_path__ + "static/media/solution_02.3bba8baf.jpg";